import { combineReducers } from 'redux';
import { DELETE_DATA_HEWAN_ERROR, DELETE_DATA_HEWAN_LOADING, DELETE_DATA_HEWAN_SUCCESS, GET_DATA_HEWAN_ERROR, GET_DATA_HEWAN_LOADING, GET_DATA_HEWAN_SUCCESS, IMPORT_DATA_HEWAN_ERROR, IMPORT_DATA_HEWAN_LOADING, IMPORT_DATA_HEWAN_SUCCESS, INITIAL_STATE, SAVE_DATA_HEWAN_ERROR, SAVE_DATA_HEWAN_LOADING, SAVE_DATA_HEWAN_SUCCESS, UPDATE_DATA_HEWAN_ERROR, UPDATE_DATA_HEWAN_LOADING, UPDATE_DATA_HEWAN_SUCCESS } from './actions';

const getDataHewan = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_DATA_HEWAN_LOADING:
            return {
                ...INITIAL_STATE,
                status: 'loading',
                loading: action.loading
            }
        case GET_DATA_HEWAN_SUCCESS:
            return {
                ...INITIAL_STATE,
                status: 'success',
                success: action.success,
                data: action.data
            }
        case GET_DATA_HEWAN_ERROR:
            return {
                ...INITIAL_STATE,
                status: 'error',
                error: action.error
            }
        default:
            return {
                ...state,
                status: ''
            }
    }
}

const saveDataHewan = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SAVE_DATA_HEWAN_LOADING:
            return {
                ...INITIAL_STATE,
                status: 'loading',
                loading: action.loading
            }
        case SAVE_DATA_HEWAN_SUCCESS:
            return {
                ...INITIAL_STATE,
                status: 'success',
                success: action.success,
                data: action.data
            }
        case SAVE_DATA_HEWAN_ERROR:
            return {
                ...INITIAL_STATE,
                status: 'error',
                error: action.error
            }
        default:
            return {
                ...state,
                status: ''
            }
    }
}

const updateDataHewan = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case UPDATE_DATA_HEWAN_LOADING:
            return {
                ...INITIAL_STATE,
                status: 'loading',
                loading: action.loading
            }
        case UPDATE_DATA_HEWAN_SUCCESS:
            return {
                ...INITIAL_STATE,
                status: 'success',
                success: action.success,
                data: action.data
            }
        case UPDATE_DATA_HEWAN_ERROR:
            return {
                ...INITIAL_STATE,
                status: 'error',
                error: action.error
            }
        default:
            return {
                ...state,
                status: ''
            }
    }
}

const deleteDataHewan = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case DELETE_DATA_HEWAN_LOADING:
            return {
                ...INITIAL_STATE,
                status: 'loading',
                loading: action.loading
            }
        case DELETE_DATA_HEWAN_SUCCESS:
            return {
                ...INITIAL_STATE,
                status: 'success',
                success: action.success,
                data: action.data
            }
        case DELETE_DATA_HEWAN_ERROR:
            return {
                ...INITIAL_STATE,
                status: 'error',
                error: action.error
            }
        default:
            return {
                ...state,
                status: ''
            }
    }
}

const importDataHewan = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case IMPORT_DATA_HEWAN_LOADING:
            return {
                ...INITIAL_STATE,
                status: 'loading',
                loading: action.loading
            }
        case IMPORT_DATA_HEWAN_SUCCESS:
            return {
                ...INITIAL_STATE,
                status: 'success',
                success: action.success,
                data: action.data
            }
        case IMPORT_DATA_HEWAN_ERROR:
            return {
                ...INITIAL_STATE,
                status: 'error',
                error: action.error
            }
        default:
            return {
                ...state,
                status: ''
            }
    }
}



const dataHewanReducer = combineReducers({
    getData: getDataHewan,
    save: saveDataHewan,
    update: updateDataHewan,
    delete: deleteDataHewan,
    import: importDataHewan
})

export default dataHewanReducer